<template>
  <div>
    
  </div>
</template>

<script>
import { ElLoading } from 'element-plus'

export default {
  setup(props) {
    const options = {
      lock: true,
      background: 'rgba(0, 0, 0, 0.5)',
      text: "系統載入中",
    }
    ElLoading.service(options)
    
    const close = () => {
      loadingInstance.close()
    }
    return {
      close,
    }
  }
}
</script>
